import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { getAllInstructions } from "../api/studnetinstruction";
import { useEffect, useState } from 'react';
import "../../App.css"
function StudentInstruction() {
    const navigate = useNavigate();
    const [instructions, setInstructions] = useState([]);
    const [error, setError] = useState('');
    const [selectedPdf, setSelectedPdf] = useState(null);

    const handleContinue = () => {
        navigate('/student-dashboard');
    };

    const token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const instructionResponse = await getAllInstructions(token);
                const data = instructionResponse.data;
                console.log("Instruction data", data);
                if (data && data.length > 0) {
                    const pdfBlob = base64ToBlob(data[0].instructionDocument, 'application/pdf');
                    const pdfUrl = URL.createObjectURL(pdfBlob);
                    setSelectedPdf(pdfUrl);
                }
                setInstructions(data);
            } catch (error) {
                console.error("Error fetching instructions:", error.response || error.message);
                setError('Error fetching data: ' + (error.response?.data?.message || error.message));
            }
        };
        fetchInitialData();
    }, [token]);
    

    const base64ToBlob = (base64, contentType) => {
        const byteCharacters = atob(base64);
        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: contentType });
    };
    return (
        <>
            <Container fluid>
                <Row >
                    <Col>
                        <Card>
                            <Card.Body>
                               <Container>
                               <Row>
                                    <Col>

                                        <Row>
                                            <div style={{ display: 'flex', justifyContent: 'space-between',alignItems: "center" }}>
                                             <Form.Label style={{ color: "#6e48aa", fontWeight: "600" }}>Instructions</Form.Label>
                                                <Button variant="primary" type="button" onClick={handleContinue}>
                                                    Continue <KeyboardDoubleArrowRightIcon />
                                                </Button>
                                            </div>
                                        </Row>
                                        <hr/>

                                        <Row>
                                            <Col>
                                                {instructions.length > 0 ? (
                                                    <ul>
                                                        {instructions.map((item, index) => (
                                                            <li key={index}>
                                                                {item.instruction}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                ) : (
                                                    <p>No instructions available.</p>
                                                )}
                                            </Col>
                                        </Row>

                                        <Row className="mt-2">
                                            <Col>
                                                {selectedPdf ? (
                                                    <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%' }}>
                                                        <iframe
                                                            src={selectedPdf}
                                                            title="Instruction Document"
                                                            style={{
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: 0,
                                                                width: '100%',
                                                                height: '100%',
                                                                border: 'none',
                                                            }}
                                                        />
                                                    </div>
                                                ) : (
                                                    <p>Loading document...</p>
                                                )}
                                            </Col>
                                        </Row> 

                                    </Col>
                                </Row>
                               </Container>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default StudentInstruction;


